/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_CommitInputs */

const en_mobile_ota_commit = /** @type {(inputs: Mobile_Ota_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit`)
};

const es_mobile_ota_commit = /** @type {(inputs: Mobile_Ota_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit`)
};

/**
* | output |
* | --- |
* | "Commit" |
*
* @param {Mobile_Ota_CommitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_commit = /** @type {((inputs?: Mobile_Ota_CommitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_CommitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_commit(inputs)
	return en_mobile_ota_commit(inputs)
});